<h1 mat-dialog-title class="alert-wrapper__title">
  {{ data.titleText || 'NO TITLE PROVIDED' }}
</h1>
<div mat-dialog-content class="alert-wrapper__content">
  <ng-template appDialogTemplateInjector> </ng-template>
  <div *ngIf="data.contentText">{{ data.contentText }}</div>
</div>
